import type { FC } from "react";
import { BarcodeScanIcon, FanProtectOutlineIcon, HistoryIcon, SeatIcon } from "@stubhub/broadway-web/icons/functional";
import { Content } from "src/shared/components/content";
import { BenefitCard, type BenefitCardProps } from "./BenefitCard";
import { contentIds } from "./contentIds";
import { benefitsGrid } from "./styles";

export const BenefitGrid: FC = () => {
  const benefits: BenefitCardProps[] = [
    {
      icon: <HistoryIcon size={20} />,
      title: <Content id={contentIds.benefitOnTimeTitle} />, // "Tickets in time"
      description: <Content id={contentIds.benefitOnTimeDesc} />, //"Your tickets will be "
      sectionId: "tickets_in_time",
    },
    {
      icon: <BarcodeScanIcon size={20} />,
      title: <Content id={contentIds.benefitValidTitle} />, // "Tickets are valid"
      description: <Content id={contentIds.benefitValidDesc} />, // "Tickets will scan at the venue and match your order."
      sectionId: "tickets_are_valid",
    },
    {
      icon: <SeatIcon size={20} />,
      title: <Content id={contentIds.benefitEventProtectionTitle} />, // "Event protection"
      description: <Content id={contentIds.benefitEventProtectionDesc} />, // "Cancelled event? Get a refund or 120% credit for future use."
      sectionId: "event_protection",
    },
    {
      icon: <FanProtectOutlineIcon size={20} />,
      title: <Content id={contentIds.benefitSupportTitle} />, // "24/7 support"
      description: <Content id={contentIds.benefitSupportDesc} />, // "If something goes wrong, our specialists work to make it right."
      sectionId: "24_7_support",
    },
  ];

  return (
    <div className={benefitsGrid}>
      {benefits.map((benefit) => (
        <BenefitCard key={benefit.sectionId} {...benefit} />
      ))}
    </div>
  );
};
